import { render, staticRenderFns } from "./Boards.vue?vue&type=template&id=1f0257e3&scoped=true&"
import script from "./Boards.vue?vue&type=script&lang=js&"
export * from "./Boards.vue?vue&type=script&lang=js&"
import style0 from "./Boards.vue?vue&type=style&index=0&id=1f0257e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0257e3",
  null
  
)

export default component.exports